/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddInstituteHeaderRequest
 */
export interface AddInstituteHeaderRequest {
    /**
     * First custom line of the prescription header
     * @type {string}
     * @memberof AddInstituteHeaderRequest
     */
    customLine1?: string | null;
    /**
     * Second custom line of the prescription header
     * @type {string}
     * @memberof AddInstituteHeaderRequest
     */
    customLine2?: string | null;
}

/**
 * Check if a given object implements the AddInstituteHeaderRequest interface.
 */
export function instanceOfAddInstituteHeaderRequest(value: object): value is AddInstituteHeaderRequest {
    return true;
}

export function AddInstituteHeaderRequestFromJSON(json: any): AddInstituteHeaderRequest {
    return AddInstituteHeaderRequestFromJSONTyped(json, false);
}

export function AddInstituteHeaderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddInstituteHeaderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'customLine1': json['customLine1'] == null ? undefined : json['customLine1'],
        'customLine2': json['customLine2'] == null ? undefined : json['customLine2'],
    };
}

export function AddInstituteHeaderRequestToJSON(json: any): AddInstituteHeaderRequest {
    return AddInstituteHeaderRequestToJSONTyped(json, false);
}

export function AddInstituteHeaderRequestToJSONTyped(value?: AddInstituteHeaderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customLine1': value['customLine1'],
        'customLine2': value['customLine2'],
    };
}

